import React from 'react';
import { Route, Routes } from 'react-router-dom';
import WelcomeTopic from './topics/welcome';
import Topic900 from './topics/topic900';
import Topic1000 from './topics/topic1000';
import Topic1400 from './topics/topic1400';
import TopicQuiz from './topics/topicQuiz';
import Topic1600 from './topics/topic1600';

export interface IGeneralStaffProps {
  topicName: string;
  topicSettings: any;
}

export function Cybersecurity2025(props: IGeneralStaffProps) {
  return (
    <Routes key={props.topicName}>
      <Route
        path="/"
        element={<WelcomeTopic settings={props.topicSettings} />}
      />
      <Route
        path="/welcome"
        element={<WelcomeTopic settings={props.topicSettings} />}
      />
      <Route
        path="/900am"
        element={<Topic900 settings={props.topicSettings} />}
      />
      <Route
        path="/1000am"
        element={<Topic1000 settings={props.topicSettings} />}
      />
      <Route
        path="/1230pm"
        element={<Topic1400 settings={props.topicSettings} />}
      />
      <Route
        path="/400pm"
        element={<Topic1600 settings={props.topicSettings} />}
      />
      <Route
        path="/quiz"
        element={<TopicQuiz settings={props.topicSettings} />}
      />
    </Routes>
  );
}
